import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { payerOptions, statusOptions } from "../careGapConstants";
import PayerChip from "./payerChip";

const EditCareGapDialog = ({
  open,
  onClose,
  form,
  setForm,
  submitting,
  onSave,
}) => {
  const togglePayer = (payer) => {
    setForm((prev) => {
      const exists = prev.payers.includes(payer);
      return {
        ...prev,
        payers: exists
          ? prev.payers.filter((p) => p !== payer)
          : [...prev.payers, payer],
      };
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontSize: 18, fontWeight: 700 }}>
        Edit Care Gap
      </DialogTitle>

      <DialogContent sx={{ mt: 1 }}>
        <Stack spacing={1.5}>
          <TextField
            select
            label="Status"
            size="small"
            value={form.status}
            onChange={(e) => setForm({ ...form, status: e.target.value })}
            fullWidth
          >
            {statusOptions.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Source"
            size="small"
            value={form.sourceType}
            onChange={(e) =>
              setForm({
                ...form,
                sourceType: e.target.value,
                payers: [],
              })
            }
            fullWidth
          >
            <MenuItem value="AI">AI & Scribe</MenuItem>
            <MenuItem value="PAYER">Payer / ACO</MenuItem>
          </TextField>

          {form.sourceType === "PAYER" && (
            <Box>
              <Typography fontSize={12} mb={1}>
                Payer / ACO
              </Typography>

              <Stack direction="row" spacing={0.8} flexWrap="wrap" useFlexGap>
                {payerOptions.map((payer) => (
                  <PayerChip
                    key={payer}
                    payer={payer}
                    small
                    selected={form.payers.includes(payer)}
                    onClick={() => togglePayer(payer)}
                  />
                ))}
              </Stack>
            </Box>
          )}

          <TextField
            label="Notes"
            size="small"
            multiline
            rows={4}
            value={form.notes}
            onChange={(e) => setForm({ ...form, notes: e.target.value })}
            fullWidth
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={
            submitting || (form.sourceType === "PAYER" && !form.payers.length)
          }
          sx={{
            textTransform: "none",
            fontWeight: 700,
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCareGapDialog;
